import { render, staticRenderFns } from "./GoalsPage.vue?vue&type=template&id=4d4fffe4&"
import script from "./GoalsPage.vue?vue&type=script&lang=js&"
export * from "./GoalsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports